import { CompressMethod } from '../xmlConvert/compiler';
import { convertImageBlob } from './lvImgConv/convert';
import {
  getCacheKey,
  getConvertParams,
  getImageData,
  imageCahcehIdb,
  needCacheConvertData
} from './utils/image.utls';
import { getColorFmtDict } from './utils/color-format-dict';
import { encode } from './utils/encode.utils';

export const blockByteDict: {
  [key: string]: number;
} = {
  argb8888: 4,
  xrgb8888: 4,
  xrgb8888_a: 4,
  rgb565: 2,
  rgb565_a: 2,
  axrgb88565: 4,
  argb8565: 3,
  rgb565swap_a: 2,
  rgb565swap: 2,
  alpha1: 1,
  alpha2: 1,
  alpha4: 1,
  alpha8: 1,
  indexed1: 1,
  indexed2: 1,
  indexed4: 1,
  indexed8: 1,
  argb4444: 4
};

export const watchEditionCompressConfig = {
  L61: 'RLEReversed' as CompressMethod,
  L67: 'RLE' as CompressMethod
};

async function _pngConvert(options: {
  imgPath: string;
  format: string;
  is16bpp: boolean;
}): Promise<Buffer> {
  const { imgPath, format = 'argb8888', is16bpp = true } = options;
  const { data, width, height } = await getImageData(imgPath); //传入图片路径并通过canvas转后的二进制路径
  let binary: Buffer;

  if (!is16bpp && format != 'indexed8') {
    const rgbaData: number[][] = [];
    for (let i = 0; i < data.length; i += 4) {
      // [R, G, B, A]
      rgbaData.push([data[i], data[i + 1], data[i + 2], data[i + 3]]);
    }
    binary = await getColorFmtDict(format)?.(rgbaData, width, height);
  } else {
    // 需要使用png conver进行处理
    const params = await getConvertParams({
      imgPath,
      format,
      is16bpp
    });
    if (!params) throw '获取参数有误，请检查';
    const { imgData, width, height, options } = params;
    const arrayBuffer = await convertImageBlob(imgData, width, height, {
      cf: options.cf,
      binaryFormat: options.binaryFormat
    });
    binary = Buffer.from(arrayBuffer);
  }

  return binary;
}

const getThenCacheImageCoverBuffer = async (data: {
  imgPath: string;
  format: string;
  is16bpp: boolean;
}) => {
  const { imgPath, format, is16bpp } = data;
  let cacheKey = '';
  let buf: Buffer | undefined = undefined;
  // 判断是否需要缓存
  if (needCacheConvertData({ is16bpp, format })) {
    try {
      cacheKey = await getCacheKey({
        imgPath,
        format,
        is16bpp
      }).then((r) => r ?? '');
      const ab: ArrayBuffer = cacheKey
        ? await imageCahcehIdb.getItem(cacheKey)
        : undefined;
      if (ab) {
        buf = Buffer.from(ab);
      }
    } catch (error) {
      buf = undefined;
    }
  }

  if (!buf) {
    console.time('重新处理图片 ' + imgPath);
    const bufNew = await _pngConvert({ imgPath, format, is16bpp });
    console.timeEnd('重新处理图片 ' + imgPath);

    // 是否存入缓存
    if (bufNew && cacheKey) {
      const ab = bufNew.buffer;
      await imageCahcehIdb?.putItem(cacheKey, ab);
    }

    buf = bufNew;
  }
  return buf;
};

const pngConvert = async (
  imgPath: string,
  format = 'argb8888' as string,
  compressMethod: CompressMethod | undefined,
  is16bpp = true
) => {
  if (!Object.keys(blockByteDict).includes(format)) format = 'indexed8';

  // 能够走到这里，说明需要进convert
  const buf = await getThenCacheImageCoverBuffer({ imgPath, format, is16bpp });
  if (!buf) return;

  // 是否进行压缩
  const compress = (['RLEReversed', 'RLE'] as CompressMethod[]).includes(
    compressMethod as CompressMethod
  );
  if (compress) {
    let colorFormatByte = 1;
    if (is16bpp) {
      if (format === 'argb8565') colorFormatByte = 3;
      else if (format === 'rgb565') colorFormatByte = 2;
      else colorFormatByte = blockByteDict[format];
    } else colorFormatByte = blockByteDict[format];
    return encode(buf, compressMethod, colorFormatByte);
  } else {
    return buf;
  }
};
export default pngConvert;
